module.exports = __webpack_public_path__ + "static/banner4-bdd0f7ac900e0bc11fb9115f6d3f7dbe.png";